/**
 * BarcodeFilters Component - Filter panel for barcode page
 */
import React from 'react';
import { MultiSelectFilter, FilterOption } from '../MultiSelectFilter';

interface BarcodeFiltersProps {
  clienteOptions: FilterOption[];
  categoriaOptions: FilterOption[];
  selectedClientes: (string | number)[];
  setSelectedClientes: (values: (string | number)[]) => void;
  selectedCategorias: (string | number)[];
  setSelectedCategorias: (values: (string | number)[]) => void;
  searchNome: string;
  setSearchNome: (value: string) => void;
  searchCodigo: string;
  setSearchCodigo: (value: string) => void;
  resultsCount: number;
  totalCount: number;
  resultLabel: string;
  // Legacy props - mantidos para compatibilidade mas não utilizados
  fabricanteOptions?: FilterOption[];
  selectedFabricantes?: (string | number)[];
  setSelectedFabricantes?: (values: (string | number)[]) => void;
}

export const BarcodeFilters: React.FC<BarcodeFiltersProps> = ({
  clienteOptions,
  categoriaOptions,
  selectedClientes,
  setSelectedClientes,
  selectedCategorias,
  setSelectedCategorias,
  searchNome,
  setSearchNome,
  searchCodigo,
  setSearchCodigo,
  resultsCount,
  totalCount,
  resultLabel,
  // Legacy props - ignorados (dropdown Fabricante removido)
  fabricanteOptions: _fabricanteOptions,
  selectedFabricantes: _selectedFabricantes,
  setSelectedFabricantes: _setSelectedFabricantes,
}) => {
  return (
    <div className="mt-4 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Filtros Avançados</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Search by name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nome do Produto
          </label>
          <input
            type="text"
            placeholder="Digite parte do nome..."
            value={searchNome}
            onChange={(e) => setSearchNome(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
          />
        </div>

        {/* Search by code */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Código do Produto
          </label>
          <input
            type="text"
            placeholder="Digite o código..."
            value={searchCodigo}
            onChange={(e) => setSearchCodigo(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
          />
        </div>

        {/* Filter by client */}
        {clienteOptions.length > 0 && (
          <div>
            <MultiSelectFilter
              label="Cliente"
              options={clienteOptions}
              selectedValues={selectedClientes}
              onChange={setSelectedClientes}
              placeholder="Selecione clientes..."
            />
          </div>
        )}

        {/* Filter by category */}
        {categoriaOptions.length > 0 && (
          <div>
            <MultiSelectFilter
              label="Categoria"
              options={categoriaOptions}
              selectedValues={selectedCategorias}
              onChange={setSelectedCategorias}
              placeholder="Selecione categorias..."
            />
          </div>
        )}
      </div>

      {/* Results info */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <p className="text-sm text-gray-600">
          Mostrando {resultsCount} de {totalCount} {resultLabel}
        </p>
      </div>
    </div>
  );
};
